<template>
	<section class="walletRecord">
		<Nav title="钱包记录" />
		<section v-if="isData">
			<van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="已全部加载完成" @load="loadMore">
				<div class="item" v-for="item in list" :key="item.id">
					<div class="left">
                        <p>{{item.transSubject | f_transSubject}}</p>
						<i>{{item.gmtCreate}}</i>
					</div>
					<div class="right">
						<p v-if="item.transType == 0" class="plus">+{{item.transAmount | f_currency}}</p>
						<p v-else class="minus">-{{item.transAmount | f_currency}}</p>
						<i>余额{{item.walletBalanceAfter | f_currency}}</i>
					</div>
				</div>
			</van-list>
		</section>
		<section v-else class="nodata_class">
			<div class="no_data">
				<img src="../../../assets/img/no_data.png">
				<p>暂无记录</p>
			</div>
		</section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import settingServer from "api/setting";
export default {
	components: {
		Nav,
	},
	data() {
		return {
			isData: 1,
			list: [],
			loading: false,
			finished: false,
			num: 1,
			params: {
				pageNum: 0,
				pageSize: 20,
			}
		}
	},
	mounted() {
		this.loadMore()
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		loadMore() {
			this.loading = true
			this.params.pageNum++
			settingServer.getWalletReocrdPageList(this.params).then((res) => {
				if(this.params.pageNum == 1) {
					if(!res.data.list || res.data.list.length==0) {
						this.isData = 0
					}
				}
				this.list = this.list.concat(res.data.list) 
				this.loading = false
				if(res.data.list.length<20) {
					this.finished = true
				}
			})
		},
	}
}
</script>

<style lang="scss">
	.walletRecord {
		padding-top: 46px;
		.item {
			display: flex;
			justify-content: space-between;
			padding: 15px;
			background: #fff;
			border-top: 1Px solid #f6f6f6;
			i {
				display: block;
				font-style: normal;
				padding-top: 7px;
				color: #a2a6ae;
				font-size: 12px;
			}
			.left {
				p {
					font-size: 16px;
					color: #2B2F3A;
				}
			}
			.right {
				p {
					font-size: 16px;
					font-weight: bold;
					text-align: right;
				}

				p.plus{
					color: #055CE8;
				}

				p.minus {
					color: #ff3a3a;
				}

				i {
					font-size: 13px;
				}
			}
		}
		.nodata_class {
			position: relative;
			.no_data {
				position: fixed;
				top: 46%;
				left: 50%;
				transform: translate(-50%, -50%);
				img {
					width: 93px;
					display: block;
				}
				p {
					padding-top: 38px;
					color: #575E72;
					font-size: 16px;
					text-align: center;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/wallet/Record.vue